module.exports = __webpack_public_path__ + "img/main.0ef523d5.jpg";